import "./InfoMenu.scss";

import { Dropdown } from "react-bootstrap";

import { QuestionIcon } from "../icons/QuestionIcon";

const InfoMenu = () => {
  return (
    <Dropdown>
      <Dropdown.Toggle variant="outline-light" className="no-arrow">
        <QuestionIcon />
      </Dropdown.Toggle>
      <Dropdown.Menu align="end" renderOnMount={false}>
        <Dropdown.Item
          href="https://cogcache.readme.io/reference/quick-start"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Documentation</span>
        </Dropdown.Item>
        <Dropdown.Item
          href="https://support.touchcast.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Support</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export { InfoMenu };
